module.exports = __webpack_public_path__ + "img/body-care-4.c64985c.webp";